module.exports = {
  aiPanelTooltipExpiryDate: '2025-12-01T00:00:00.000Z',
  spellcheckerFakeDoorTestExpiryDate: '2025-04-05T00:00:00.000Z',
}
